import { render, staticRenderFns } from "./mher.vue?vue&type=template&id=f1369d6e&lang=pug"
import script from "./mher.vue?vue&type=script&setup=true&lang=js"
export * from "./mher.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mher.vue?vue&type=style&index=0&id=f1369d6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports